export default "__VITE_ASSET__Bcdc_ruQ__"